module.exports = __webpack_public_path__ + "img/qr_code.8dd897c2.png";